export const Endpoint = () => `/api/v3/admin/organizations_remove/`;
export const Csrf = () => `/api/v3/admin/token/`;
export declare const QueryKey: never;
export type Payload = {
    id: string;
};
export type Response = void;
